<template>
  <div>
    <Header :pageTitle="'支付'" @backFn="backFn" v-if="!isApp && !livePage">
      <template #cancelOrder>
        <div
          class="cancelBtn"
          v-show="orderInfo.payStatusText === '未支付'"
          @click.stop="cancelOrder"
        >
          取消订单
        </div>
      </template>
    </Header>
    <orderHeader v-else-if="Number(livePage) == 1 && isApp"></orderHeader>
    <!--TODO 旧订单详情 -->
    <dl class="orderInfo">
      <dt>
        <div
          class="item"
          v-if="orderInfo.meetingNames && orderInfo.meetingNames.length > 0"
          style="
            display: block;
            height: auto;
            line-height: 1.35;
            padding: 0.24rem 0;
          "
        >
          <div v-for="(name, idx) in orderInfo.meetingNames" :key="idx">
            {{ name }}
          </div>
        </div>
        <div class="item">
          <div>订单编号</div>
          <div>{{ $route.params.orderId }}</div>
        </div>
        <div class="item" v-if="orderInfo.title">
          <div>商品</div>
          <div>{{ orderInfo.title }}</div>
        </div>
        <div class="item" v-else>
          <div>参会人员</div>
          <div>{{ orderInfo.attendees || orderInfo.userName }}</div>
        </div>
        <div class="item" v-if="orderInfo.couponCount">
          <div>数量</div>
          <div>{{ orderInfo.couponCount }} 张</div>
        </div>
        <div class="item" v-if="orderInfo.orderName">
          <div>订单名称</div>
          <div>{{ orderInfo.orderName }}</div>
        </div>
        <div class="item" v-show="orderInfo.totalAmount">
          <div>售价</div>
          <div
            class="price"
            v-if="isIos && orderInfo.meetingType == 3 && isApp"
          >
            &yen;
            {{ orderInfo.payMoney && Number(orderInfo.payMoney).toFixed(2) }}
          </div>
          <div class="price" v-else>&yen; {{ orderInfo.totalAmount }}</div>
        </div>
        <div class="item" v-show="orderInfo.discountAmount">
          <div>优惠金额</div>
          <div class="price">
            {{ Number(orderInfo.discountAmount).toFixed(2) }}
          </div>
        </div>
        <div
          class="item"
          v-show="orderInfo.discountAmount"
          v-if="orderInfo.isVipPay === 2"
        >
          <div>OMO/会员折扣</div>
          <div class="price">
            &yen;
            {{
              orderInfo.vipDiscountAmount &&
              Number(orderInfo.vipDiscountAmount).toFixed(2)
            }}
          </div>
        </div>
      </dt>
      <dd>
        <div class="item" v-if="orderInfo.couponCount > 0">
          <div>优惠券</div>
          <div>
            {{ orderInfo.couponText }}
            <span style="color: #f95046"
              >- &yen;
              {{
                orderInfo.vipDiscountAmount &&
                Number(orderInfo.vipDiscountAmount).toFixed(2)
              }}</span
            >
          </div>
        </div>
        <div class="item">
          <div>交易金额</div>
          <!-- ios 线上共学营展示 payMoney -->
          <div
            class="price"
            v-if="isIos && orderInfo.meetingType == 3 && isApp"
          >
            &yen;
            {{ orderInfo.payMoney && Number(orderInfo.payMoney).toFixed(2) }}
          </div>
          <div class="price" v-else>
            &yen;
            {{
              (orderInfo.payAmount && Number(orderInfo.payAmount).toFixed(2)) ||
              (orderInfo.payMoney && Number(orderInfo.payMoney).toFixed(2))
            }}
          </div>
        </div>
      </dd>
      <dd
        v-show="orderInfo.isVipPay != 2"
        v-if="!isApp || !isIos || (orderInfo.meetingType !== 3 && isIos)"
      >
        <div class="item" @click.stop="checkType(1)">
          <div class="icon">
            <img class="icon-wechat" src="@/assets/icon/wechat.png" alt="" />
            <span>微信支付</span>
          </div>
          <div class="radio">
            <img
              v-show="payType === 1"
              class="icon-check"
              src="@/assets/icon/icon_checked.png"
              alt=""
            />
            <img
              v-show="payType === 2"
              class="icon-check"
              src="@/assets/icon/icon_unchecked.png"
              alt=""
            />
          </div>
        </div>
        <div class="item" @click.stop="checkType(2)">
          <div class="icon">
            <img class="icon-alipay" src="@/assets/icon/alipay.png" alt="" />
            <span>支付宝</span>
          </div>
          <div class="radio">
            <img
              v-show="payType === 1"
              class="icon-check"
              src="@/assets/icon/icon_unchecked.png"
              alt=""
            />
            <img
              v-show="payType === 2"
              class="icon-check"
              src="@/assets/icon/icon_checked.png"
              alt=""
            />
          </div>
        </div>
      </dd>
      <div
        class="nextBtn"
        :class="{ grayBg: orderStatus.pay }"
        v-show="loaded"
        @click.stop="submitPay"
      >
        <span>{{ orderStatus.text }}</span>
      </div>
    </dl>
    <div class="backTip" v-show="back && showBack">
      <dl class="tipContent">
        <dt>您的支付未完成是否继续支付？</dt>
        <dd>
          <div class="cancel" @click.stop="backFn">我放弃了</div>
          <div class="continue" @click.stop="payAgain">继续支付</div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { meetReq, payReq } from '@/api/index'
import Header from '@/components/common/Header.vue'
import app from '@/widget/app'
import { hostPath, payApi2 } from '@/public/utils/basePath'
import orderHeader from './orderHeader.vue'
import {
  getCookie,
  setCookie,
  wechatPort,
  appPort,
  getUserId,
  applePayOnline,
  iOSPort,
  prevPageView
} from '@/widget'
import {
  getExerciseOrderInfo,
  getMeetOrderInfo,
  updateOrder
} from '@/api/meeting'
export default defineComponent({
  name: 'orderpay',
  props: {
    livePage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orderInfo: {},
      payType: 1,
      wechat: wechatPort(),
      isApp: appPort(),
      isIos: iOSPort(),
      back: false,
      showBack: false,
      openId: '',
      loaded: false
    }
  },
  computed: {
    orderStatus() {
      let obj = {
        pay: false,
        text: '立即支付'
      }
      if (
        this.orderInfo.payStatusText === '已支付' ||
        (this.orderInfo.orderStatus !== 0 && this.orderInfo.orderStatus) ||
        this.orderInfo.orderType === 2
      ) {
        obj.pay = true
      }
      if (
        this.orderInfo.payStatusText === '未支付' ||
        this.orderInfo.orderStatus === 0 ||
        this.orderInfo.orderType === 1
      ) {
        obj.text = '立即支付'
        obj.pay = false
      } else {
        obj.text = this.orderInfo.payStatusText || '已支付'
      }
      if (this.orderInfo.isVipPay === 2) {
        obj.text = '确认预定'
      }
      return obj
    }
  },
  methods: {
    getOrderInfo() {
      if (this.$route.params.module === 'exercise') {
        getExerciseOrderInfo({
          orderId: this.$route.params.orderId
        }).then(res => {
          if (res.code === 200) {
            this.orderInfo = res.data
            this.loaded = true
            if (this.wechat && !this.openId && this.orderInfo.isVipPay !== 2) {
              this.wechatReady()
            }
          }
        })
      } else {
        let orderId = this.$route.params.orderId
        let params = {}
        // ios 共学营订单
        if (this.isIos && /^OL*/.test(orderId) && this.isApp) {
          params.ios = true
          params.h5site = false
        }
        getMeetOrderInfo(
          {
            userId: getUserId(),
            orderId: orderId,
            module: this.$route.params.module
          },
          { params }
        ).then(res => {
          if (res.code === 200) {
            this.loaded = true
            this.orderInfo = res.data
            if (this.wechat && !this.openId && this.orderInfo.isVipPay !== 2) {
              this.wechatReady()
            }
            if (this.orderStatus.pay) {
              this.showBack = false
            } else {
              this.showBack = true
            }
          }
        })
      }
    },
    cancelOrder() {
      meetReq
        .cancelOrder({
          orderIds: this.$route.params.orderId
        })
        .then(res => {
          if (res.code === 200) {
            this.$toast('取消成功')
            this.prevPage()
          }
        })
    },
    checkType(id) {
      if (id === this.payType) {
        return
      }
      if (this.isApp) {
        this.payType = id
      } else {
        this.$toast(
          id === 1 ? '当前环境不支持微信支付' : '当前环境不支持支付宝支付'
        )
      }
    },
    submitPay() {
      if (
        this.orderInfo.payStatusText === '已支付' ||
        (this.orderInfo.orderStatus !== 0 && this.orderInfo.orderStatus) ||
        this.orderInfo.orderType === 2
      ) {
        this.$toast('订单已支付')
        return
      }
      if (this.orderInfo.isVipPay === 2) {
        // 免费订单
        updateOrder({
          userId: getUserId(),
          orderId: this.orderInfo.orderId
        }).then(res => {
          if (res.code === 200) {
            this.paySuccess()
          }
        })
        return
      }
      const meetingType = this.orderInfo.meetingType
      const module = this.$route.params.module
      if (this.isIos && this.isApp && meetingType == 3) {
        // ios 支付
        applePayOnline({
          type: 'online',
          orderId: this.orderInfo.orderId,
          meetingId: this.orderInfo.meetingId,
          applePayId: this.orderInfo.payId
        })
        return
      }
      // meetingType 0-学习班 1-训练营 2-OMO训练营 3- 线上共学营
      this.$showLoading()
      if (this.isApp) {
        // APP 支付
        this.payOrder()
        return
      }
      if (this.payType === 2) {
        app.aliPay.call(
          this,
          {
            module
          },
          {
            orderId: this.orderInfo.orderId,
            returnUrl: `${hostPath}/learn/order/payresult/${
              this.$route.params.module
            }/${this.orderInfo.orderId}?backUrl=${this.getBackUrl()}`
          }
        )
      } else {
        this.wechatCode()
        // app.wxPay.call(this,
        //   { module: this.$route.params.module },
        //   {
        //     orderId: this.orderInfo.orderId,
        //     openId: this.openId || Store.get('openId', 'local')
        //   }
        // )
      }
    },
    getBackUrl() {
      const num = this.orderInfo.meetingType
      let reffer = document.reffer
      if (reffer && reffer != location.href) {
        return reffer
      }
      // TODO 这里需要修改
      if (num === 2 || num == 3) {
        return `${hostPath}/learn/courseguide/train/${this.orderInfo.meetingId}`
      } else {
        return location.href
      }
    },
    backFn() {
      if (this.back) {
        this.back = false
        this.showBack = false
        this.prevPage()
      } else if (this.showBack) {
        this.back = true
      } else {
        this.back = false
        this.showBack = false
        this.prevPage()
      }
    },
    prevPage() {
      if (history.length > 2) {
        if (this.wechat) {
          history.go(-2)
        } else {
          history.go(-1)
        }
      } else {
        location.assign(hostPath)
      }
    },
    paySuccess() {
      // 微信支付成功回调
      this.$router.replace({
        name: 'orderResult',
        params: {
          orderId: this.$route.params.orderId
        },
        query: {
          backUrl: this.getBackUrl()
        }
      })
    },
    payPopup() {
      // 支付取消提示
      this.back = true
    },
    wechatCode() {
      if (this.openId) {
        this.wechatPay()
      } else {
        payReq
          .getWechatCodeInfo({
            code: this.$route.query.code
          })
          .then(res => {
            if (res.code === 200) {
              this.openId = res.data.openId
              setCookie('openId', this.openId, Infinity)
              localStorage.setItem('openId', this.openId)
              // 去除链接中的code
              this.$router.replace({
                name: this.$route.name
              })
              this.wechatPay()
            } else {
              this.$hideLoading()
              this.$toast(res.message + ' 错误码：' + res.code)
            }
          })
      }
    },
    wechatPay() {
      payReq
        .getWechatSign({
          params: { module: this.$route.params.module },
          query: {
            orderId: this.orderInfo.orderId,
            openId: this.openId
          }
        })
        .then(res => {
          this.$hideLoading()
          if (res.code === 200) {
            let sign = res.data
            window.WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                appId: sign.appId,
                timeStamp: sign.timeStamp,
                nonceStr: sign.nonceStr,
                package: sign.packageValue,
                signType: sign.signType,
                paySign: sign.paySign
              },
              res => {
                if (res.err_msg === 'get_brand_wcpay_request:ok') {
                  this.paySuccess()
                } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                  this.payPopup()
                } else {
                  this.paySuccess()
                }
              }
            )
          }
        })
    },
    wechatReady() {
      if (typeof WeixinJSBridge === 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', this.setEnv, false)
      } else {
        this.setEnv()
      }
    },
    setEnv() {
      this.payType = 1
      if (!this.$route.query.code) {
        this.wechatAuth()
      }
    },
    wechatAuth() {
      // 微信 code 校验
      if (wechatPort()) {
        let base = payApi2 + '/wechat/auth?redirectURI='
        let redirectUrl = `${window.location.protocol}//${
          window.location.host + '/learn' + this.$route.path
        }`
        window.location.replace(base + redirectUrl)
      }
    },
    payOrder() {
      app.appPay.call(this, {
        platform: this.payType === 1 ? 'wechat' : 'alipay',
        module: this.$route.params.module,
        type: 'app',
        orderId: this.$route.params.orderId
      })
    },
    payAgain() {
      this.back = false
      if (!this.openId && !this.isApp) {
        this.wechatAuth()
      }
    },
    getEndTime() {
      var time = Date.now()
      return new Date(time + 1800 * 1000)
    },
    visibleChange() {
      if (document.visibilityState == 'visible') {
        this.getOrderInfo()
      }
    }
  },
  mounted() {
    if (!this.isApp) {
      if (this.wechat) {
        this.payType = 1
        this.openId =
          getCookie('openId') || localStorage.getItem('openId') || ''
      } else {
        this.payType = 2
      }
    } else {
      window.payCallback = () => {
        this.paySuccess()
      }
      if (this.ios) {
        // 苹果支付成功，返回上一页
        window.currentPageUpdate = () => {
          prevPageView()
        }
      }
    }
    this.getOrderInfo()
    document.addEventListener('visibilitychange', this.visibleChange, false)
  },
  unmounted() {
    if (this.isApp) {
      delete window.payCallback
      if (this.ios) {
        delete window.currentPageUpdate
      }
    }
    document.removeEventListener('visibilitychange', this.visibleChange, false)
  },
  components: {
    Header,
    orderHeader
  }
})
</script>

<style lang="scss" scoped>
.price {
  color: $themeColor;
  font-size: 28px;
}
.cancelBtn {
  height: 87px;
  line-height: 87px;
  color: $themeColor;
  font-size: 32px;
  padding-right: 32px;
}
.item {
  height: 88px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 -1px 0 $grayF5 inset;
  align-items: center;
}
.orderInfo {
  font-size: 28px;
  dd,
  dt {
    padding: 0 32px;
    background: #fff;
    .item:last-child {
      box-shadow: none;
    }
  }
  dt {
    padding-top: 16px;
  }
  dd {
    margin-top: 16px;
  }
  .icon {
    display: flex;
    align-items: center;
    img {
      margin-right: 12px;
    }
  }
}
.nextBtn {
  width: 686px;
  height: 88px;
  background: #ff6600;
  border-radius: 44px;
  margin: 96px auto 0;
  text-align: center;
  line-height: 96px;
  color: #fff;
  span {
    display: inline-block;
    width: 100%;
    height: 88px;
  }
}
.backTip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba($color: #000000, $alpha: 0.6);
  .tipContent {
    width: 540px;
    height: 260px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
    left: 50%;
    top: 50%;
    margin-left: -270px;
    margin-top: -130px;
    text-align: center;
    dt {
      height: 140px;
      line-height: 140px;
      font-size: 32px;
    }
    dd {
      display: flex;
      justify-content: space-between;
      padding: 0 32px;
      font-size: 28px;
      line-height: 72px;
    }
    .cancel,
    .continue {
      width: 212px;
      height: 72px;
      border-radius: 36px;
    }
    .cancel {
      background: #f5f5f7;
    }
    .continue {
      color: #fff;
      background: $themeColor;
    }
  }
}
</style>
